import React from 'react';

import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ArrowRightIcon } from '@mui/x-date-pickers-pro';

import InfoTooltipIcon from 'components/InfoTooltipIcon';

import useStyles from './styles';

type Props = {
  id: string;
  text: string;
  infoText?: string;
  onClick: () => void;
  ariaLabel: string;
};

const TaxNavButton = ({ id, text, infoText, onClick, ariaLabel }: Props) => {
  const { classes } = useStyles();

  return (
    <Stack id={`${id}-btn`} direction='row' alignItems='center' justifyContent='flex-end'>
      {infoText && <InfoTooltipIcon size='small-no-padding' tooltipText={infoText} />}
      <ButtonBase
        aria-label={ariaLabel}
        onClick={onClick}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'inherit' }}
      >
        <Typography variant='paragraphMedium' className={classes.taxInfoBtn}>
          {text}
        </Typography>
        <ArrowRightIcon className={classes.arrow} />
      </ButtonBase>
    </Stack>
  );
};

export default TaxNavButton;
